// Overview subsection questionnaire constants
export enum OverviewQuestionnaireItem {
  RESUMPTION_OVERVIEW_OVERVIEW = 'resumption-overview/overview',
  RESUMPTION_OVERVIEW_OVERVIEW_ROC_DATE = 'resumption-overview/overview/roc-date',
  RESUMPTION_OVERVIEW_OVERVIEW_INPATIENT_DISCHARGE_DATE = 'resumption-overview/overview/inpatient-discharge-date',
  RESUMPTION_OVERVIEW_OVERVIEW_REASON_FOR_INPATIENT_STAY = 'resumption-overview/overview/reason-for-inpatient-stay',
  RESUMPTION_OVERVIEW_OVERVIEW_INPATIENT_DISCHARGE_INSTRUCTIONS = 'resumption-overview/overview/inpatient-discharge-instructions',
  RESUMPTION_OVERVIEW_OVERVIEW_COMMENTS = 'resumption-overview/overview/comments'
}
